import React, { useRef, useState } from "react";
import { CFormText, CInput } from "@coreui/react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { useSelector } from "react-redux";
import { setSelected } from "../redux/notificationsSagas";
import { useDispatch } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";
import "react-datetime/css/react-datetime.css";

import Schedule from "./Schedule";
const ApiKey = "4s5k7eycj7if2wqloseymce2v43xdla40ezz52521ygdvjii";

export const Filters = () => {
  const dispatch = useDispatch();
  const editorRef = useRef(null);
  const {
    selected: { all_organizations: all, organization_ids, published, message, title },
    currentUser: { organizations: allOrganizations }
  } = useSelector((state) => state.notifications);
  const [touched, setTouched] = useState(false);

  const getIds = (orgs) => {
    return orgs.map((org) => org.id);
  };

  const selectedOrganizations = allOrganizations.filter((org) => {
    return organization_ids.includes(org.id);
  });

  const onClickAll = (isActive) => {
    dispatch(setSelected({ all_organizations: isActive }));

    if (isActive) {
      dispatch(setSelected({ organization_ids: getIds(allOrganizations) }));
    } else {
      dispatch(setSelected({ organization_ids: [] }));
    }
  };

  const onClickPublish = (isActive) => {
    dispatch(setSelected({ published: isActive }));
  };

  function imageDimensionsAsStyle(images) {
    if (images.length > 0) {
      [...images].forEach((image) => {
        let width = image.getAttribute("width");
        let height = image.getAttribute("height");
        image.style.width = width + "px";
        image.style.height = height + "px";
      });
    }
  }

  const onChange = (message, editor) => {
    imageDimensionsAsStyle(editor.contentDocument.images);

    dispatch(setSelected({ message }));
  };

  const onOrganizationChange = (orgs) => {
    dispatch(setSelected({ organization_ids: getIds(orgs) }));
    if (orgs.length === allOrganizations.length) {
      dispatch(setSelected({ all_organizations: true }));
    } else {
      dispatch(setSelected({ all_organizations: false }));
    }
  };

  const titleChange = (title) => {
    dispatch(setSelected({ title: title }));
  };

  const saveFile = (cb, value, meta) => {
    let input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.onchange = function () {
      let file = this.files[0];
      let reader = new FileReader();
      reader.onload = function () {
        let id = "fileId" + new Date().getTime();
        let blobCache = tinymce.activeEditor.editorUpload.blobCache;
        let base64 = reader.result.split(",")[1];
        let blobInfo = blobCache.create(id, file, base64);
        blobCache.add(blobInfo);
        cb(blobInfo.blobUri(), { title: file.name });
      };
      reader.readAsDataURL(file);
    };
    input.click();
  };

  return (
    <>
      <div className="notifications__section">
        <div className="switch">
          <p className="switch__title">Send to all organizations</p>
          <div className={`switch__content ${all ? "switch__content--active" : ""}`}>
            <ToggleableButton isRadio title="Orgs" isActive={all} onClick={onClickAll} />
          </div>
        </div>

        <div className="switch">
          <p className="switch__title">Publish</p>
          <div className={`switch__content ${published ? "switch__content--active" : ""}`}>
            <ToggleableButton
              isRadio
              title="Publish"
              isActive={published}
              onClick={onClickPublish}
            />
          </div>
        </div>
      </div>

      <div className="notifications__section light">
        <div className="notifications__section__el">
          <p>Organizations</p>
          <Dropdown
            height={275}
            haveOnSelectChange
            placeholder="Select Organizations"
            options={allOrganizations}
            selectedFilters={selectedOrganizations}
            enableDefaultSelected
            enableOnly
            includeSelectAll
            numberDisplayed={3}
            onSelectChange={(data) => onOrganizationChange(data)}
          />
          <CFormText className="help-block">
            {selectedOrganizations.length == 0 ? "Please choose at least 1 organization" : ""}
          </CFormText>
        </div>

        <div className="notifications__section__el">
          <p>Title</p>
          <CInput
            onChange={(e) => titleChange(e.target.value)}
            className="text-input"
            type="text"
            placeholder="Add Notification Title"
            value={title}
          />
          <CFormText className="help-block">
            {title && title.trim()
              ? title.length > 64
                ? "* Text limit is 64 characters"
                : ""
              : "* Please add notification title"}
          </CFormText>
        </div>
      </div>
      <Schedule />
      <div className="notifications__section notifications__section__bottom">
        <Editor
          apiKey={ApiKey}
          onInit={(evt, editor) => (editorRef.current = editor)}
          init={{
            height: 430,
            menubar: false,
            statusbar: false,
            automatic_uploads: true,
            file_picker_types: "image",
            file_picker_callback: saveFile,
            paste_data_images: true,
            plugins: ["image", "link"],
            toolbar_mode: "floating",
            font_size_formats: "12px 14px 16px 18px 24px 36px",
            style_formats: [
              { title: "Bold text", inline: "strong" },
              { title: "Red text", inline: "span", styles: { color: "#ff0000" } }
            ],
            toolbar:
              "undo redo fontsize | bold italic link| backcolor forecolor | \
                aligncenter | \
               | image",
            browser_spellcheck: true
          }}
          value={message}
          onEditorChange={onChange}
          onBlur={() => setTouched(true)}
        />
        <CFormText className="help-block">
          {touched && message.length == 0 ? "Please type notification text" : ""}
        </CFormText>
      </div>
    </>
  );
};
